<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="combinedAudits && combinedAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="combinedAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Event audits </ng-template>

  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let staffEventBusinessPerson of staffEvent.staffEventBusinessPersons"
      (opened)="staffEventBusinessPersonOpened(staffEventBusinessPerson)"
    >
      <mat-expansion-panel-header>
        <span
          >{{ staffEventBusinessPerson.lastName }}, {{ staffEventBusinessPerson.firstName }}</span
        >
        <span *ngIf="staffEventBusinessPerson.isDeleted">&nbsp;(Deleted)</span>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <sd-portal-staff-event-business-person-audit-list
          #staffEventBusinessPersonAuditList
          [staffEventBusinessPerson]="staffEventBusinessPerson"
          [loading]="staffEventBusinessPersonLoading"
          [staffEventBusinessPersonAudits]="staffEventBusinessPersonAudits"
          (loadStaffEventBusinessPerson)="loadStaffEventBusinessPerson.emit($event)"
          (nextPage)="loadNextStaffEventBusinessPersonPage.emit($event)"
        >
        </sd-portal-staff-event-business-person-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
